<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-align-right`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 5c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v38c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V5zm-8 31a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 011-1h26a1 1 0 011 1v8zm-1-15a1 1 0 001-1v-8a1 1 0 00-1-1H17a1 1 0 00-1 1v8a1 1 0 001 1h16z"/></svg>
</template>
<script>

export default {
  name: 'IconAlignRight',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
